import React, { Component } from 'react';
import _ from 'lodash';
import denormalize from 'json-api-denormalizer'
import { connect } from 'react-redux';
import * as actions from './actions';

class StudentGroupingsContainer extends Component {
  componentDidMount() { this.fetchStudentGroupings() }

  fetchStudentGroupings = ()=> actions.fetchStudentGroupings(this.props.dispatch)

  childProps = ()=>{
    const { isFetching, fetchError, collection, ...rest } = this.props
    return({
      studentGroupingsProps: { isFetching, fetchError, collection }, ...rest
    })
  }

  render() {
    return(
      React.cloneElement(React.Children.only(this.props.children), this.childProps())
    );
  }
}

const mapStateToProps = state => {
  return {
    ...(state.studentGroupings || {}),
    collection: denormalize(state.api || {}).courses || {}
  }
}

export default connect(mapStateToProps)(StudentGroupingsContainer);
